export default __webpack_public_path__ + "e4ed50222911c5af9a323ebbef9c3d1a.svg";